export const routes = {
  index: "/",
  login: "/logowanie",
  myImages: "/moje-zdjecia",
};
